<template>
    <v-row justify="center" class="w-100">
        <v-col lg="10" sm="12">
            <h1>Достижения и награды</h1>                      

            <v-timeline align-top dense>
                <v-timeline-item>
                    <v-btn color="primary" @click="showAddEditDialog()">Добавить</v-btn>
                </v-timeline-item>

                <v-timeline-item v-for="(item, key) in list.data" :key="key">
                    <v-card elevation="2" v-if="Object.keys(list).length != 0">
                        <v-card-title class="pb-0">
                            <v-spacer></v-spacer>
                            <v-dialog>
                                <template v-slot:activator="{ on: menu, attrs }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on: tooltip }">
                                            <v-btn
                                              color="primary"
                                              fab
                                              text
                                              small
                                              v-bind="attrs"
                                              v-on="{ ...tooltip, ...menu }"
                                            >
                                                <v-icon color="red">mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Удалить запись</span>
                                    </v-tooltip>
                                </template>
                                
                                <v-card max-width="400px">
                                    <v-card-title class="text-h5">Удалить запись</v-card-title>
                                    <v-card-text>
                                        Вы действительно хотите удалить запись?
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>

                                        <v-btn
                                            color="green darken-1"
                                            text
                                            @click.stop="closeSubmit()"
                                        >
                                            Нет
                                        </v-btn>

                                        <v-btn
                                            color="green darken-1"
                                            text
                                            @click.stop="deleteSubmit(key)"
                                        >
                                            Да
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        class="ml-2"
                                        fab
                                        text
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        @click.stop="showAddEditDialog({id: key, item: item})"
                                    >
                                        <v-icon color="teal">mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                                <span>Добавить запись</span>
                            </v-tooltip>
                        </v-card-title>
                        <v-card-text class="request-data card-text-custom pt-4">
                            <v-form class="form" ref="myForm">
                                <v-col lg="12" class="item-row" v-for="(headerItem, headerKey) in list.header" :key="headerKey">
                                    <v-row style="font-size: 16px;">
                                        <v-col md="5"><b>{{ headerItem.name }}:</b></v-col>
                                        <v-col md="7">
                                            <template v-if="headerItem.type == 'text' || headerItem.type == 'number' || headerItem.type == 'email' || headerItem.type == 'date'">
                                                {{ item[headerKey].value }}
                                            </template>
                                            <template v-else-if="headerItem.type == 'base64'">
                                                <a :href="item[headerKey].value" target="_blank"><v-img max-width="100%" class="m-auto" width="150px" :src="item[headerKey].value" aspect-ratio="1.5" /></a>
                                            </template>
                                            <template v-else-if="headerItem.type == 'tag'">
                                                {{ item[headerKey].values.map(el => el.name).join(', ') }}
                                            </template>
                                            <template v-else>
                                                {{ item[headerKey].value.name }}
                                            </template>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-timeline-item>
            </v-timeline>
        </v-col>

        <v-dialog v-model="addEditDialog" width="700">
            <v-card>
                <v-card-title class="headline lighten-2">Добавить</v-card-title>

                <v-card-text>
                    <v-form class="form" ref="addEditForm" @submit.prevent="addEditSubmit()">
                        <div lg="12" class="item-row" v-for="(headerItem, headerKey) in list.header" :key="headerKey">
                            <v-text-field 
                                v-if="headerItem.type == 'text' || headerItem.type == 'email'" 
                                v-model="addEditData.item[headerKey]" 
                                :label="headerItem.name" 
                                :disabled="!headerItem.can_change"
                                :type="headerItem.type"
                                :error-messages="fieldsError[headerKey]"
                                :rules="[v => !headerItem.required || !!v || 'Обязательное поле']">
                            </v-text-field>

                            <v-text-field 
                                v-else-if="headerItem.type == 'number'" 
                                v-model="addEditData.item[headerKey]" 
                                :label="headerItem.name" 
                                :disabled="!headerItem.can_change"
                                type="text"
                                :error-messages="fieldsError[headerKey]"
                                :rules="[v => !headerItem.required || !!v || 'Обязательное поле', v => v > 0 || 'Неправильный формат']">
                            </v-text-field>

                            <v-menu v-else-if="headerItem.type == 'date'" :nudge-right="30" :nudge-top="25" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field 
                                        v-model="addEditData.item[headerKey]" :label="headerItem.name" readonly prepend-icon="mdi-calendar" 
                                        :error="fieldsError[headerKey] != undefined"
                                        :rules="[v => !headerItem.required || !!v || 'Обязательное поле']" :disabled="!headerItem.can_change" required v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker locale="ru-RU" v-model="addEditData.item[headerKey]" :max="(new Date()).toISOString().split('T')[0]"></v-date-picker>
                            </v-menu>

                            <div v-else-if="headerItem.type == 'base64'">
                                <v-file-input
                                    :label="headerItem.name" 
                                    :accept="headerItem.accept" 
                                    :disabled="!headerItem.can_change"
                                    :error-messages="fieldsError[headerKey]"
                                    :rules="[v => !headerItem.required || !!v || 'Обязательное поле', v => !v || v.size < headerItem.max_allowed_size*1024*1024 || 'Размер файла не должен превышать '+headerItem.max_allowed_size+' Мб']" 
                                    @change="toBase64($event, headerKey)"
                                    required>
                                </v-file-input>
                            </div>

                            <v-autocomplete v-else-if="headerItem.type == 'tag'"
                                :items="reference[headerItem.tag_name]"
                                :label="headerItem.name"
                                :item-disabled="referencesDisabledItem"
                                item-text="name"
                                :item-value="headerItem.tag_id"
                                v-model="addEditData.item[headerKey]"
                                :disabled="!headerItem.can_change"
                                multiple
                                :error-messages="fieldsError[headerKey]"
                                :rules="[v => !headerItem.required || Object.keys(v).length != 0 || 'Обязательное поле']">
                            </v-autocomplete>

                            <v-autocomplete v-else-if="headerItem.type == 'reference'"
                                :items="reference[headerItem.reference_name]" 
                                :item-disabled="referencesDisabledItem"
                                item-text="name"
                                v-model="addEditData.item[headerKey]" 
                                :disabled="!headerItem.can_change" 
                                :item-value="headerItem.reference_id" 
                                :label="headerItem.name"
                                :error-messages="fieldsError[headerKey]"
                                :rules="[v => !headerItem.required || !!v || 'Обязательное поле']"
                            >
                            </v-autocomplete>

                            <v-switch
                                v-else-if="headerItem.type == 'boolean'"
                                v-model="addEditData.item[headerKey]"
                                :label="headerItem.name"
                                :disabled="!headerItem.can_change"
                                :error-messages="fieldsError[headerKey]"
                                :rules="[v => !headerItem.required || 'Обязательное поле']">
                            ></v-switch>
                        </div>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :loading="isLoading" text @click="addEditSubmit()">
                        Добавить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            category: 'achievement',
            list: {},
            reference: {},
            addEditDialog: false,
            addEditData: {
                id: null,
                item: {}
            },
            originalData: {},
            fieldsError: {}
        }
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        referencesDisabledItem(v) {
            return v.id == 1;
        },
        async getInfo() {
            this.addEditDialog = false;
            await this.$http.get('https://api.portfolio.edus.kz/v1/ru/detail/'+this.category).then((response) => {
                this.list = response.data;
            }).catch(err => { 
                console.log(err);
            });
        },
        async getReferences() {
            for(let key in this.list.header) {
                let item = this.list.header[key];
                if(((item.type == 'reference' && !this.reference[item.reference_name]) || (item.type == 'tag' && !this.reference[item.tag_name])) && item.can_change) {
                    let refName = item.type == 'reference' ? item.reference_name : item.tag_name;
                    await this.$http.get('https://api.portfolio.edus.kz/v1/ru/reference/'+refName).then((response) => {
                        this.reference[refName] = response.data;
                    }).catch(err => {
                        console.log(err)
                    });
                }
            }
        },
        async addEditSubmit() {
            if(this.$refs.addEditForm.validate()) {
                this.isLoading = true;
                if(this.addEditData.id) {
                    let editData = this.getChanges(this.originalData, this.addEditData.item);

                    if(Object.keys(editData).length != 0) {
                        await this.$http.patch('https://api.portfolio.edus.kz/v1/ru/detail/'+this.category+'/'+this.addEditData.id, editData).then(() => {
                            this.getInfo();
                            this.isLoading = false;
                        }).catch(err => { 
                            console.log(err);
                            this.isLoading = false;
                        });  
                    } else {
                        this.addEditDialog = false;
                        this.isLoading = false;
                    }
                } else {
                    await this.$http.post('https://api.portfolio.edus.kz/v1/ru/detail/'+this.category, this.addEditData.item).then(() => {
                        this.getInfo();
                        this.isLoading = false;
                    }).catch(err => { 
                        if (err.response.status === 400 && err.response.data.fields) {
                            this.fieldsError = err.response.data.fields;
                        }
                        this.isLoading = false;
                    });
                }
            }
        },
        async deleteSubmit(id) {
            await this.$http.delete('https://api.portfolio.edus.kz/v1/ru/detail/'+this.category+'/'+id).then((response) => {
                this.$store.dispatch('alertAdd', {text: response.data.message, type: 'success'});
                delete this.list.data[id];
                this.$forceUpdate();
            }).catch(err => { 
                console.log(err);
            });
        },
        showAddEditDialog(data = null) {
            this.addEditData = {
                id: null,
                item: {}
            };
            this.fieldsError = {};
            this.originalData = {};
            if(data) {
                this.addEditData.id = data.id;
                for (let [headerKey, headerItem] of Object.entries(this.list.header)) {
                    if(!data.item[headerKey].values) {
                        if(headerItem.type == 'reference') {
                            this.addEditData.item[headerKey] = data.item[headerKey].value[headerItem.reference_id];
                        } else {
                            this.addEditData.item[headerKey] = data.item[headerKey].value;
                        }
                    } else {
                        this.addEditData.item[headerKey] = data.item[headerKey].values.map(el => el[headerItem.tag_id]);
                    }
                }
                this.originalData = Object.assign({}, this.addEditData.item);
            }
            this.getReferences().then(() => this.addEditDialog = true);
        },
        toBase64(file, key) {
            this.addEditData.item[key] = null;
            if(file) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
                    if ((encoded.length % 4) > 0) {
                        encoded += '='.repeat(4 - (encoded.length % 4));
                    }
                    this.addEditData.item[key] = encoded;
                };
            }
        },
        getChanges(originalData, newData) {
            let changedData = {};
            for (let key in originalData) {
                if(originalData[key] != newData[key]) {
                    changedData[key] = newData[key];
                }
            }
            return changedData;
        }
    },
    watch: {
        // addEditDialog: function (v) {
        //     if(!v) {
        //         //this.addEditData = {};
        //     }
        // },
    },
    components: {},
}
</script>